import { render } from "./ResultItem.vue?vue&type=template&id=1b5cf249&scoped=true"
import script from "./ResultItem.vue?vue&type=script&lang=js"
export * from "./ResultItem.vue?vue&type=script&lang=js"

import "./ResultItem.vue?vue&type=style&index=0&id=1b5cf249&lang=scss&scoped=true"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5cf249"]])

export default __exports__